export * from './createComponent';
export * from './IComponent';
export * from './IHTMLSlots';
export * from './ISlots';
export * from './slots';
export * from './ThemeProvider';
export * from './hooks/index';

export { styled as legacyStyled } from '@uifabric/utilities';

import './version';



// WEBPACK FOOTER //
// ../src/index.ts